import Fetch from "@/assets/js/Fetch";

let Report = function() {
  this.get = function(
    priceDate,
    baseCompetitor,
    keywords,
    competitors,
    comparisonGroup
  ) {
    return new Promise(resolve => {
      let url = process.env.VUE_APP_API + "report/";

      let data = {
        priceDate: priceDate,
        baseCompetitor: baseCompetitor,
        keywords: keywords,
        competitors: competitors,
        comparisonGroup: comparisonGroup
      };

      Fetch.run(url, "POST", data).then(result => {
        resolve(result);
      });
    });
  };
};

export default new Report();
